import { render, staticRenderFns } from "./Carrosel.vue?vue&type=template&id=9e4e1a1c&scoped=true&"
import script from "./Carrosel.vue?vue&type=script&lang=js&"
export * from "./Carrosel.vue?vue&type=script&lang=js&"
import style0 from "./Carrosel.vue?vue&type=style&index=0&id=9e4e1a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4e1a1c",
  null
  
)

export default component.exports